import { Lightning } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="text-center max-w-lg">
        <pre className="text-emerald-500 font-mono text-xs mb-8 ascii-loader">
{`
    _____ _  _    ___  _  _   
   |  |  | || |  / _ \\| || |  
   |  |  |_  _| | | | |_  _| 
   |_____|_||_| | |_| |_||_|  
                 \\___/        
`}
        </pre>
        
        <h1 className="text-4xl font-bold tracking-tight mb-4">Page Not Found</h1>
        <p className="text-zinc-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex justify-center gap-4">
          <Button 
            onClick={() => navigate(-1)}
            variant="outline"
            className="border-zinc-700"
          >
            Go Back
          </Button>
          <Button 
            onClick={() => navigate("/")}
            className="bg-emerald-500 text-black font-bold hover:bg-emerald-400 rounded-sm"
          >
            <Lightning className="w-4 h-4 mr-2" />
            Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
